// extracted by mini-css-extract-plugin
export default {"container":"styles__container___0qy5C","checkWrapper":"styles__checkWrapper___3wreF","checkIcon":"styles__checkIcon___FLAVB","titleReady":"styles__titleReady___qtpnt"};